import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconCheckCircle, IconError, IconInfo, IconRemoveCircle } from '@travel-frontend/icons';
export function getIcon(variant) {
  switch (variant) {
    case 'warning':
      return _jsx(IconError, {
        fontScale: "small"
      });
    case 'success':
      return _jsx(IconCheckCircle, {
        fontScale: "small"
      });
    case 'error':
      return _jsx(IconRemoveCircle, {
        fontScale: "small"
      });
    case 'info':
    default:
      return _jsx(IconInfo, {
        fontScale: "small"
      });
  }
}